import { combineReducers } from 'redux';
import actionTypes from './actionTypes';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

/* State shape
 loadingState: {
     isLoading: bool,
     success: bool,
     error: Object
 },
 componentSeasonState: {
     componentSeasons: Array
 }
*/

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_COMPONENT_SEASONS)
    (actionTypes.COMPONENT_SEASONS_RESPONSE);

const componentSeasonsReducer = (state = [], action) => {
    if (action.type === actionTypes.COMPONENT_SEASONS_RESPONSE) {
        return action.payload.componentSeasons;
    }
    return state;
};


const componentSeasonsStateReducer = combineReducers({
    componentSeasons: componentSeasonsReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    componentSeasonsState: componentSeasonsStateReducer
});

export default reducer;